export default __webpack_public_path__ + "static/media/Group 3172@2x.52148522.png";